var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119.07 114.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke-width: .82px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\r\n        fill-opacity: .25;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-7 {\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: none;\r\n        stroke-width: 3px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 60.69,
    y1: 68.54,
    x2: 83.89,
    y2: 42.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 55.48,
    y1: 15.38,
    x2: 63.83,
    y2: 15.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.03,
    y1: 5.14,
    x2: 72.73,
    y2: 5.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 12.68,
    y1: 67.55,
    x2: 106.4,
    y2: 67.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 95.7,
    y1: 32.1,
    x2: 118.66,
    y2: 32.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.41,
    y1: 32.1,
    x2: 23.37,
    y2: 32.1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m59.65,67.44h36.27c0-9.62-3.82-18.85-10.62-25.64s-16.03-10.62-25.64-10.62v36.27h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 59.38,
    y1: 101.65,
    x2: 59.38,
    y2: 93.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 42.4,
    y1: 97.16,
    x2: 46.67,
    y2: 89.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 29.89,
    y1: 84.63,
    x2: 37.28,
    y2: 80.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 25.44,
    y1: 67.72,
    x2: 33.79,
    y2: 67.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 29.93,
    y1: 50.42,
    x2: 37.31,
    y2: 54.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 42.46,
    y1: 37.91,
    x2: 46.72,
    y2: 45.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 59.38,
    y1: 33.23,
    x2: 59.36,
    y2: 42.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 76.67,
    y1: 37.95,
    x2: 72.4,
    y2: 45.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 89.18,
    y1: 50.48,
    x2: 81.8,
    y2: 54.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 93.86,
    y1: 67.72,
    x2: 84.96,
    y2: 67.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 89.15,
    y1: 84.69,
    x2: 81.77,
    y2: 80.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 76.61,
    y1: 97.2,
    x2: 72.36,
    y2: 89.81
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m58.03,65.91c-.87.87-.87,2.28,0,3.15h0c.87.87,2.28.87,3.15,0l12.73-15.1c.41-.52-.26-1.18-.78-.78,0,0-15.1,12.73-15.1,12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.83,9.87v11.02c-1.41-.13-2.84-.19-4.29-.19-1.37,0-2.72.06-4.06.18v-11h8.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 46.03,
    y: 0.41,
    width: 26.7,
    height: 9.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m63.83,20.89c-1.41-.13-2.84-.19-4.29-.19-1.37,0-2.72.06-4.06.18-23.98,2.05-42.8,22.17-42.8,46.68,0,25.88,20.98,46.86,46.86,46.86s46.86-20.98,46.86-46.86c0-24.44-18.7-44.5-42.58-46.66Zm-4.29,82.93c-20.03,0-36.27-16.24-36.27-36.27S39.51,31.28,59.54,31.28s36.27,16.24,36.27,36.27-16.24,36.27-36.27,36.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.66,38.25l-5.86,4.18-4.21-5.9-9.11,6.5c-1.13-1.85-2.4-3.62-3.78-5.28l9.11-6.5-4.21-5.9,5.86-4.18,12.19,17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.26,31.25l9.12,6.5c-1.37,1.67-2.64,3.43-3.78,5.28l-9.11-6.5h0s-4.21,5.9-4.21,5.9L.41,38.25l12.19-17.08,5.86,4.18-4.21,5.9h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.a26ca2a2c385f595eea9352762446097.svg";
export { ForwardRef as ReactComponent };